<template>
  <div>
    <v-app class="app-tabela">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
        >
          <template v-slot:header.situacao="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              :title="header.tooltip"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} registros</span
            >
          </template>

          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada.</b>
            </div>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            <td>{{ formatDate(item.dt_nascimento) }}</td>
          </template>
          <template v-slot:item.dt_atendimento="{ item }">
            <td>{{ formatDate(item.dt_atendimento) }}</td>
          </template>
          <template v-slot:item.dt_procedimento="{ item }">
            <td>{{ formatDate(item.dt_procedimento) }}</td>
          </template>

          <template v-slot:item.nu_ine="{ item }">
            <td>
              {{ item.nu_ine }}
              <span
                v-b-tooltip.hover.right
                :title="item.no_equipe"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-app>
    <div class="alert-duplicados" v-if="alert.show">
      Cadastros, provavelmente, duplicados.
      <ul>
        <li>
          Caso sejam pessoas diferentes, é indicado atualizar todos os cadastros
          mencionados com o CPF correspondente;
        </li>
        <li>
          Se for confirmada a duplicação, recomenda-se proceder com a unificação
          dos prontuários do cidadão.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Duplicados',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
  },
  mixins: [utils],
  data() {
    return {
      headers: [
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_cns',
        },
        {
          text: 'NOME',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'no_cidadao',
        },
        {
          text: 'NASCIMENTO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'MÃE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_mae',
        },
        {
          text: 'PAI',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_pai',
        },
      ],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
      alert: {
        show: false,
      },
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Busca os dados
     */
    async buscarDados() {
      try {
        this.loading = true
        const response = await this.$api.post(`/app/cidadao/duplicados`, {
          co_ibge: this.$store.state.cod_ibge,
          id: this.cidadao.id,
          id_master: this.cidadao.id_master,
        })
        this.alert.show = false
        if (response) {
          const temMaisDeUm = response.data.length > 1
          const algumCpfNulo = response.data.some((item) => item.nu_cpf == null)
          this.alert.show = temMaisDeUm && algumCpfNulo
          if (temMaisDeUm) {
            this.cadastros = response.data
          } else {
            this.cadastros = []
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.alert-duplicados {
  background: #ffb366;
  border: 1px solid orange;
  padding: 20px;
  margin-top: 20px;
  ul {
    padding: 10px 30px;
    list-style-type: disc;
  }
}
</style>
